import { render, staticRenderFns } from "./BlotterDetails.vue?vue&type=template&id=e300ddb0"
import script from "./BlotterDetails.vue?vue&type=script&lang=js"
export * from "./BlotterDetails.vue?vue&type=script&lang=js"
import style0 from "./BlotterDetails.vue?vue&type=style&index=0&id=e300ddb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports